import { RoutePrefix } from '#/routing/classes/RoutePrefix';

export const embedSearchWidgetPrefix = new RoutePrefix(
  '/:lang/embed-search-widget/:embedSearchWidgetId',
);
